<article>
  @switch (currentView) {
    @case (pageViews.DEFINITION) {
      <section>
        <app-definition (selectedTabName)="getTabName($event)" (composerActions)="onComposerActions($event)" [productImage]="productImage"></app-definition>
      </section>
    }
    @case (pageViews.HISTORY) {
      <section>
        @if (data) {
          <app-history [info]="data"></app-history>
        }
      </section>
    }
  }
</article>
